<template>
    <div
        :style="componentStyles"
        class="o-guide-qr-code"
    >
        <div class="guide-qr-code-header">
            <span class="guide-qr-code-title">
                {{ 'ui.way.get_route' | translate }}
            </span>
            <span class="guide-qr-code-subtitle">
                {{ 'ui.way.scan_qr' | translate }}
            </span>
        </div>
        <div class="guide-qr-code-placeholder">
            <OQrCodeGenerator />
        </div>
        <button
            type="button"
            class="guide-qr-code-button"
            @click="openModal"
        >
            {{ 'ui.way.send_sms' | translate }}
        </button>
        <OSmsModalStandard />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";

import qrcode from "qrcode-generator";

import OSmsModalStandard from '../../organisms/o-sms-modal-standard';
import OQrCodeGenerator from '../o-qr-code-generator/o-qr-code-generator';

import { EVENTS } from "@/utils/constants/bus-events-constants";

export default {
    name: "OGuideQrCode",
    props: {
        itemId: {
            type: Number,
            required: true
        },
        view: {
            type: String,
            default: ''
        }
    },
    components: {
        OQrCodeGenerator,
        OSmsModalStandard
    },
    data() {
        return {
            placeholder: true,
            qrTimeout: null,
        }
    },
    computed: {
        ...mapState({
            mapId: state => state.map.id,
            activePath: state => state.activePath,
            activeLocale: state => state.activeLocale,
            terminalAppUrl: state => state.map.meta.terminal_app_url
        }),
        ...mapGetters([
            'getMapConfigProp',
            'getObjectModelIds',
            'getTerminalId'
        ]),
        componentStyles() {
            return this.getMapConfigProp(`views.${this.view}.mainFrame.OGuideSidebar.params.OGuideQrCode.styles`) || null;
        }
    },
    itemId() {
        this.qrTimeout = setTimeout(() => {
            this.renderQr()
        }, 2000)
    },
    mounted() {
        this.qrTimeout = setTimeout(() => {
            this.renderQr()
        }, 2000)
    },
    methods: {
        renderQr() {
            if(!this.$refs.qr)
                return;

            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const from =  this.getTerminalId || this.$route.query.from || '';
            const qr = qrcode(typeNumber, errorCorrectionLevel);
            const mode = this.$route.params.mode || 'fast';
            let origin =  location.origin;
            if(origin.includes('192.168.')){
                origin = origin.replace('http://', 'https://');
            }
            if(origin.includes('localhost')){
                origin = this.terminalAppUrl.replace(/(http|https):\/\/([^\/]*)\/.*/,'https://$2');
            }
            const url = origin+ '/' + `map-${this.mapId}/mobile/guide/${mode}?to=${this.itemId}&from=${from}&lang=${this.activeLocale}&redirect-from=qr`
            console.log(url);
            qr.addData(url);
            qr.make();
            this.$refs.qr.innerHTML = qr.createSvgTag({ cellSize:3.5, margin: 0});
            this.placeholder = false;
        },
        openModal() {
            const config = {
                view: this.view,
                itemId: this.itemId
            };

            this.$bus.$emit(EVENTS.MODALS.INIT_SMS_MODAL_STANDARD, config);
        }
    },
    beforeDestroy() {
        clearTimeout(this.qrTimeout)
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
